import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DatenschutzPage } from './Datenschutz';
import { ComponentsModule } from "../../components/components.module"

@NgModule({
  declarations: [
    DatenschutzPage,
  ],
  imports: [
    IonicPageModule.forChild(DatenschutzPage),
	ComponentsModule
  ],
})
export class DatenschutzPageModule {}



// WEBPACK FOOTER //
// ./src/pages/Datenschutz/Datenschutz.module.ts